import {
  CalendarDateTime,
  fromDate,
  getLocalTimeZone,
  toCalendarDateTime,
  toZoned,
} from "@internationalized/date";
import { z } from "zod";

export const dateTimeSchemaResponse = z.coerce
  .date()
  .transform((time) => toCalendarDateTime(fromDate(time, getLocalTimeZone())));
export type DateTimeResponse = z.infer<typeof dateTimeSchemaResponse>;
/**
 * Both CalendarDateTime and ZonedDateTime works for most cases as they're really similiar
 * But, if your current time is winter time and you select a date in summer time, then
 * ZonedDateTime will give the incorrect timeZone. CalendarDateTime is therefore used as the default.
 */
export const dateTimeSchemaForm = z.custom<CalendarDateTime>();
export type DateTimeForm = z.infer<typeof dateTimeSchemaForm>;

export const dateTimeSchemaRequest = z
  .custom<CalendarDateTime>()
  .transform((date) => toZoned(date, getLocalTimeZone()).toString());
export type DateTimeRequest = z.infer<typeof dateTimeSchemaRequest>;

// We don't run a full parse for Form -> Request, therefore we need to manually parse this field
export function dateTimeFormToRequest(
  dateTimeForm: DateTimeForm,
): DateTimeRequest {
  return dateTimeSchemaRequest.parse(dateTimeForm);
}
